/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Plan_Feat3Inputs */

const en_builder_plan_feat3 = /** @type {(inputs: Builder_Plan_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 short plans & 40 agent messages / month`)
};

const id_builder_plan_feat3 = /** @type {(inputs: Builder_Plan_Feat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 rencana ringkas & 40 pesan agent / bulan`)
};

/**
* | output |
* | --- |
* | "3 short plans & 40 agent messages / month" |
*
* @param {Builder_Plan_Feat3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const builder_plan_feat3 = /** @type {((inputs?: Builder_Plan_Feat3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Plan_Feat3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builder_plan_feat3(inputs)
	return en_builder_plan_feat3(inputs)
});